import Vue from "vue";
import surveyCompiledMixin from "@/mixins/surveyCompiledMixin";
export default Vue.extend({
    mixins: [surveyCompiledMixin],
    props: {
        templateConfig: {}
    },
});
